import network from '../../Network/NetworkManager';

const SETTINGS_URL = 'v1/rentals/settings';

export const getRentalSettings = async listingId =>
  network.networkCall(`${SETTINGS_URL}/${encodeURIComponent(listingId)}`, 'GET', '');

export const saveRentalSettings = async (listingId, settings) =>
  network.networkCall(SETTINGS_URL, 'POST', JSON.stringify({listing_id: listingId, ...settings}));

export const updateRentalSettings = async (listingId, settings) =>
  network.networkCall(`${SETTINGS_URL}/${encodeURIComponent(listingId)}`, 'PUT', JSON.stringify(settings));
